import { FormLabel, TextField } from '@mui/material';
import { VerticalLayoutUI } from './VerticalLayout';
import colors from './colors';
import { iconName } from './iconNames';
import { IconUI } from './IconUI';
import { TextUI } from './Text';
import React from 'react';

export type TextfieldProps = {
  ref?: React.Ref<any>
  label?: string
  value: string
  onChange: (v: string) => void
  placeHolder?: string
  startIcon?: iconName
  endAdornment?: React.ReactElement
  width?: '100%'
  type?: 'text' | 'email' | 'password'
  fullWidth?: boolean
  multiline?: boolean
  largeLabel?: boolean
};

export const TextfieldUI: React.FC<TextfieldProps> = ({ ref, value, onChange, label, placeHolder, startIcon, endAdornment, width, type = 'text', fullWidth, multiline, largeLabel }) => {
  const startAdornment = startIcon ? <div style={{ paddingRight: '6px' }}><IconUI name={startIcon} /></div> : undefined;
  return (
    <VerticalLayoutUI width={width}>
      <FormLabel style={{ color: colors.black }}>
        {largeLabel ? label : <TextUI size="title" weight="bold">{label}</TextUI>}
      </FormLabel>
      <TextField
        ref={ref}
        value={value}
        onChange={e => onChange(e.currentTarget.value)}
        placeholder={placeHolder}
        type={type}
        slotProps={{
          input: {
            startAdornment,
            endAdornment,
          },
        }}
        size="small"
        fullWidth={fullWidth}
        multiline={multiline}
        minRows={multiline ? 3 : undefined}
      />
    </VerticalLayoutUI>
  );
};
